// This list is extracted from https://www.npmjs.com/package/common-password package
// Instead of importing a complete list, I deleted all the passwords of length < 9.
// This approach is more space efficient

const commonPasswordsList = [
  "123456789",
  "password1",
  "0987654321",
  "abcdefghti",
  "zyxwvutsrqp",
  "000000000",
  "111111111",
  "999999999",
  "welcome123",
  "password123",
  "liverpool",
  "metallica",
  "1234567890",
  "987654321",
  "microsoft",
  "deepthroat",
  "qwertyuiop",
  "asdfghjkl",
  "spiderman",
  "basketball",
  "webmaster",
  "chocolate",
  "alexander",
  "beautiful",
  "swordfish",
  "elizabeth",
  "masterbate",
  "penetration",
  "christine",
  "wolverine",
  "masterbating",
  "unbelievable",
  "intercourse",
  "squerting",
  "insertion",
  "temptress",
  "celebrity",
  "interacial",
  "streaming",
  "pertinant",
  "fantasies",
  "ejaculation",
  "businessbabe",
  "experience",
  "contortionist",
  "cheerleaers",
  "christian",
  "housewifes",
  "seductive",
  "gangbanged",
  "experienced",
  "passwords",
  "transexual",
  "gallaries",
  "lockerroom",
  "absolutely",
  "masterbaiting",
  "housewife",
  "masturbation",
  "pornographic",
  "thumbnils",
  "knickerless",
  "underwear",
  "enterprise",
  "scandinavian",
  "techniques",
  "manchester",
  "penetrating",
  "butterfly",
  "earthlink",
  "girfriend",
  "uncencored",
  "gymnastic",
  "hollywood",
  "insertions",
  "wonderboy",
  "skywalker",
  "fuckinside",
  "ursitesux",
  "stonecold",
  "christina",
  "stephanie",
  "password2",
  "quant4307s",
  "iloveyou1",
  "sebastian",
  "jamesbond",
  "iloveyou2",
  "amsterdam",
  "catherine",
  "football1",
  "charlotte",
  "christopher",
  "september",
  "123123123",
  "qwerty123",
  "southpark",
  "california",
  "tottenham",
  "barcelona",
  "katherine",
  "stoppedby",
  "christmas",
  "cocksucker",
  "birthday4",
  "something",
  "starcraft",
  "godfather",
  "password9",
  "favorite6",
  "paintball",
  "wrestling",
  "gladiator",
  "washington",
  "lightning",
  "postov1000",
  "chevrolet",
  "snowboard",
  "birthday1",
  "australia",
  "charlie123",
  "outoutout",
  "superstar",
  "pinkfloyd",
  "hurricane",
  "idontknow",
  "qazwsxedc",
  "baseball1",
  "favorite2",
  "alexandra",
  "primetime21",
  "blackjack",
  "cleveland",
  "sexsexsex",
  "letmein22",
  "fatluvr69",
  "dragonball",
  "slimed123",
  "scoobydoo",
  "highlander",
  "playstation",
  "gnasher23",
  "porn4life",
  "excalibur",
  "wednesday",
  "sweetness",
  "undertaker",
  "university",
  "moonlight",
  "president",
  "newcastle",
  "1q2w3e4r5t",
  "pimpdaddy",
  "panasonic",
  "motherfucker",
  "peternorth",
  "cardinals",
  "fortune12",
];

export default commonPasswordsList;
